import {Pagina} from "./Pagina";

class Rol {
    constructor(
        public key: number,
        public id: number,
        public nom: string,
        public pagines: Array<Pagina>,
    ) {
    }
}

const defaultRol: Rol = {
    key: 0,
    id: 0,
    nom: "",
    pagines: [],
};

export {Rol, defaultRol};
